module.exports = __webpack_public_path__ + "static/img/Ventamin_logo.b695f33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Ventamin_logo.png
// module id = dzj/
// module chunks = 0